import { render, staticRenderFns } from "./buyMember.vue?vue&type=template&id=5ce80df6&scoped=true"
import script from "./buyMember.vue?vue&type=script&lang=js"
export * from "./buyMember.vue?vue&type=script&lang=js"
import style0 from "./buyMember.vue?vue&type=style&index=0&id=5ce80df6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce80df6",
  null
  
)

export default component.exports